"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PercentageChangeByPropertyTypeItem$ = exports.PercentageChangeByPropertyTypeItem$outboundSchema = exports.PercentageChangeByPropertyTypeItem$inboundSchema = void 0;
exports.percentageChangeByPropertyTypeItemToJSON = percentageChangeByPropertyTypeItemToJSON;
exports.percentageChangeByPropertyTypeItemFromJSON = percentageChangeByPropertyTypeItemFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const propertytype_js_1 = require("./propertytype.js");
/** @internal */
exports.PercentageChangeByPropertyTypeItem$inboundSchema = z.object({
    percentage_change: z.nullable(z.number()),
    property_type: propertytype_js_1.PropertyType$inboundSchema,
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "percentage_change": "percentageChange",
        "property_type": "propertyType",
    });
});
/** @internal */
exports.PercentageChangeByPropertyTypeItem$outboundSchema = z.object({
    percentageChange: z.nullable(z.number()),
    propertyType: propertytype_js_1.PropertyType$outboundSchema,
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        percentageChange: "percentage_change",
        propertyType: "property_type",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PercentageChangeByPropertyTypeItem$;
(function (PercentageChangeByPropertyTypeItem$) {
    /** @deprecated use `PercentageChangeByPropertyTypeItem$inboundSchema` instead. */
    PercentageChangeByPropertyTypeItem$.inboundSchema = exports.PercentageChangeByPropertyTypeItem$inboundSchema;
    /** @deprecated use `PercentageChangeByPropertyTypeItem$outboundSchema` instead. */
    PercentageChangeByPropertyTypeItem$.outboundSchema = exports.PercentageChangeByPropertyTypeItem$outboundSchema;
})(PercentageChangeByPropertyTypeItem$ || (exports.PercentageChangeByPropertyTypeItem$ = PercentageChangeByPropertyTypeItem$ = {}));
function percentageChangeByPropertyTypeItemToJSON(percentageChangeByPropertyTypeItem) {
    return JSON.stringify(exports.PercentageChangeByPropertyTypeItem$outboundSchema.parse(percentageChangeByPropertyTypeItem));
}
function percentageChangeByPropertyTypeItemFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PercentageChangeByPropertyTypeItem$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PercentageChangeByPropertyTypeItem' from JSON`);
}
//# sourceMappingURL=percentagechangebypropertytypeitem.js.map